import { translate } from "@/i18n";
import { onboardingContextualMessages } from "@/i18n/messages/onboarding-contextual";
import { ensureSingletonFrame } from "./ensure-singleton-frame";

/** Ensures the project's memory (knowledge graph) frame exists and is
 *  mounted in the canvas store, creating it when this is the first visit.
 *  See `ensureSingletonFrame` for why this is safe to call unconditionally. */
export function ensureMemoryFrame(
  projectId: string,
  signal?: AbortSignal,
): Promise<string> {
  return ensureSingletonFrame(
    projectId,
    "memory",
    translate(onboardingContextualMessages, "memoryFrameTitle"),
    signal,
  );
}
